import { renderSelectOptions } from "utils";

import { ReactComponent as RemoveIcon } from "images/removeIcon.svg";

import styles from "./select.module.css";
import { DefaultSelect } from "../DefaultSelect";

interface IProps {
  value?: string[];
  onChange?: (value: string[]) => void;
  placeholder?: string;
  disabled?: boolean;
  options: Record<string, string>;
}

export const MultiplySelect = ({ value, onChange, placeholder, disabled, options }: IProps) => {
  const handleChange = (newValue: string[]) => {
    onChange?.(newValue);
  };

  const hasValue = Array.isArray(value) && value.length > 0;

  return (
    <DefaultSelect
      disabled={disabled}
      size="large"
      mode="multiple"
      value={value}
      placeholder={placeholder}
      onChange={handleChange}
      className={`${styles.multiplyInput} ${styles.input} ${hasValue ? styles.inputWithValues : ""}`}
      removeIcon={<RemoveIcon />}
      showSearch={false}
    >
      {renderSelectOptions(options)}
    </DefaultSelect>
  );
};
